module.exports = __webpack_public_path__ + "img/candidatosfavoritos.2cfb81f2.png";